"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addViews = void 0;
const command_manager_1 = require("../../command_manager");
const ot_1 = require("../../engine/ot");
const i18n_1 = require("../../exports/i18n");
const lodash_1 = require("lodash");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
exports.addViews = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data } = options;
        const datasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const views = snapshot.meta.views;
        if ((0, lodash_1.isEmpty)(data)) {
            return null;
        }
        // const checkViewCount = (viewType: ViewType) => {
        //   const spaceInfo = state.space.curSpaceInfo!;
        //
        //   if(state.pageParams.shareId){
        //     return;
        //   }
        //
        //   switch (viewType) {
        //     case ViewType.Calendar: {
        //       subscribeUsageCheck('maxCalendarViewsInSpace', spaceInfo['calendarViewNums'] + 1);
        //       return;
        //     }
        //     case ViewType.Gantt: {
        //       subscribeUsageCheck('maxGanttViewsInSpace', spaceInfo['ganttViewNums'] + 1);
        //       return;
        //     }
        //     case ViewType.Kanban: {
        //       subscribeUsageCheck('maxKanbanViewsInSpace', spaceInfo['kanbanViewNums'] + 1);
        //       return;
        //     }
        //     case ViewType.Gallery: {
        //       subscribeUsageCheck('maxGalleryViewsInSpace', spaceInfo['galleryViewNums'] + 1);
        //       return;
        //     }
        //   }
        // };
        const actions = data.reduce((collected, recordOption) => {
            const { startIndex, view } = recordOption;
            // Check if viewId exists,
            // The newly added viewid should not conflict with the current and future ids
            if (views.findIndex(item => item.id === view.id) !== -1) {
                throw new Error((0, i18n_1.t)(i18n_1.Strings.error_create_view_failed_duplicate_view_id));
            }
            // checkViewCount(view.type);
            const action = model_1.DatasheetActions.addView2Action(snapshot, { startIndex, view });
            if (!action) {
                return collected;
            }
            if (collected.length) {
                const transformedAction = ot_1.jot.transform([action], collected, 'right');
                collected.push(...transformedAction);
            }
            else {
                collected.push(action);
            }
            return collected;
        }, []);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
/*

 declare module '../../command_manager/command_manager' {
 interface CollaCommandManager {
 execute(options: IAddViewOptions & { cmd: 'AddViews' });
 }
 }

 */
//# sourceMappingURL=add_views.js.map